define.alias("shared/components/shared/ui/past-post-limit-banner", "media/components/shared/ui/past-post-limit-banner");